import { css } from 'styled-components';
import AntDesign from './ant-design';

export default css`
  ${AntDesign};
`;
